export enum MetadataUrlOrderByInput {
  id_ASC = "id__ASC",
  id_DESC = "id__DESC",
  type_url_ASC = "type_url__ASC",
  type_url_DESC = "type_url__DESC",
  url_ASC = "url__ASC",
  url_DESC = "url__DESC",
  valid_check_ASC = "valid_check__ASC",
  valid_check_DESC = "valid_check__DESC",
  exposure_order_ASC = "exposure_order__ASC",
  exposure_order_DESC = "exposure_order__DESC",
  createdAt_ASC = "createdAt__ASC",
  createdAt_DESC = "createdAt__DESC",
  updatedAt_ASC = "updatedAt__ASC",
  updatedAt_DESC = "updatedAt__DESC"
}
